module.exports = __webpack_public_path__ + "static/img/dark-real.d5cb34c0.png";